import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { fixUrlCategory } from 'utils/index';
import PubSub from 'services/PubSub';
import style from './style.scss'; //NOSONAR

let actions = [];

const SubCategories = (props) => {
    const category = props.subCategories || {};
    const [slideIn, setSlideIn] = useState(false);

    useEffect(()=>{

        actions.push(PubSub.register('subcat_slide_in', data => setSlideIn(data)));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    return (
        <>
            <div className={'subcategory-background'+(slideIn ? ' slide-in' : '')}>
                {(category && category.items && !!category.items.length) && <div className={"subcategory-list-wrap"}>
                    <div className="catalog-aside-nav-title-wrap active">
                        <h4 className="catalog-aside-nav-title">{props.title}</h4>
                    </div>
                    <ul className={'catalog-aside-subcategories-content'}>
                        <li className={"catalog-aside-subcategories-child"}>
                            {category.items.map((subcategory, i) => {
                                const url = fixUrlCategory(subcategory.url || subcategory.link);
                                return (
                                    <Link to={url} key={i} className="subcategory-name">{subcategory.name}</Link>
                                )
                            })}
                        </li>
                    </ul>
                    <div className={'back-categories'} onClick={()=>setSlideIn(false)}> {"Volver"} </div>
                </div>}
            </div>
        </>
    );
}

SubCategories.propTypes = {
    subCategories: PropTypes.object,
    title: PropTypes.string
};

export default SubCategories;
